import http from "./http";

const apiEndpoint = process.env.REACT_APP_BASE_URL + "/api/ResMgr";

export function getResMgrById(Id) {
  return http.get(`${apiEndpoint}/${Id}`);
}

export function getPagerResMgr(query, obj) {
  return http.post(`${apiEndpoint}/GetPager?${query}`, obj);
}

export function editResMgr(obj) {
  // if (obj.id !== "new") {
  //   return http.put(apiEndpoint, obj);
  // } else {
    
    return http.post(`${apiEndpoint}/Save`, obj);
  //}
}

export function deleteResMgr(Id) {
  return http.delete(`${apiEndpoint}/${Id}`);
}
